import React, { Component } from 'react';
import classNames from 'classnames';

// TODO: Remove this and allow container/Modal to handle multiple instances
class Modal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: this.props.open,
    }

    this.handleClick = this.handleClick.bind(this);
    this.handleEscKey = this.handleEscKey.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({open: nextProps.open})
  }

  className() {
    return classNames(
      'ds-container',
      this.props.className,
      { '_open': this.state.open }
    )
  }

  closeModal = () => {
    if (this.props.persistent) return;

    this.props.onClose();
    this.setState({open: false});
  }

  containerClassName() {
    return classNames(
      'ds-modal _alignTop',
      { '_open': this.state.open }
    )
  }

  modalWindowClassName() {
    return classNames(
      'modal-window',
      this.props.windowClassName,
      { 'paddingTop-0': this.props.nopad }
    )
  }

  cardClassName() {
    return classNames(
      'ds-card',
      this.props.cardClassName
    )
  }

  gridClassName() {
    return classNames(
      'grid',
      this.props.gridClassName
    )
  }

  componentWillMount() {
    if (this.props.override_esc_key) return;

    document.addEventListener("keydown", this.handleEscKey, false);
  }

  // when the component unmounts, remove the Esc key event listener
  componentWillUnmount() {
    if (this.props.override_esc_key) return;

    document.removeEventListener("keydown", this.handleEscKey, false);
  }

  handleEscKey(e) {
    if(e.keyCode === 27) {
      this.closeModal()
    }
  }

  handleClick(e) {
    if (this.props.persistent || !!e.target.closest('.ds-card')) return;

    this.closeModal()
  }

  renderCloseLink() {
    if (this.props.persistent || this.props.override_close) return;

    return (
      <button className="ds-btn -secondary --micro _icon _rounded _closeModal" onClick={this.closeModal}>
        <i className="materialIcon">close</i>
      </button>
    );
  }

  render() {
    return (
      <div className={this.containerClassName()}>
        <div className={this.className()} onClick={this.handleClick}>
          <div className={this.gridClassName()}>
            <div className={this.cardClassName()}>
              {this.renderCloseLink()}
              {this.props.children}
              {this.renderCloseLink()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Modal.defaultProps = {
  open: false,
  onClose: () => {},
  persistent: false,
  overlayTrigger: true,
};

export default Modal;



// WEBPACK FOOTER //
// ./src/features/shared/components/layouts/Modal.js